import { Link } from "react-router-dom";
import { useState } from "react";
import { Phone, Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email: email.trim(), source: "footer", send_welcome: true });
      toast.success(data.new ? "Subscribed! Check your inbox for $10 off." : "You're already on the list!");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };
  return (
    <footer className="bg-surface-dark text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="inline-block rounded-2xl bg-white p-3">
              <img src="/aap-logo.png" alt="Adopt-A-Phone — Your Smartphone Retailer" className="h-10 w-auto max-w-[280px] object-contain" />
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              Your smartphone retailer. Certified like-new iPhones — now with flexible lease-to-own financing through Payvantage.
            </p>
            <a href="tel:7709055829" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-white/90 hover:text-crimson" data-testid="footer-phone">
              <Phone className="h-4 w-4" /> (770) 905-5829
            </a>
            <form onSubmit={subscribe} className="mt-6 max-w-sm" data-testid="footer-subscribe-form">
              <label className="text-xs font-bold uppercase tracking-widest text-white/40">Get $10 off — join our list</label>
              <div className="mt-2 flex gap-2">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  data-testid="footer-subscribe-email"
                  className="w-full rounded-full border border-white/15 bg-white/5 px-4 py-2.5 text-sm text-white placeholder-white/40 outline-none focus:border-crimson"
                />
                <button type="submit" disabled={busy} data-testid="footer-subscribe-btn"
                  className="whitespace-nowrap rounded-full bg-crimson px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-white hover:text-ink disabled:opacity-50">
                  {busy ? "…" : "Subscribe"}
                </button>
              </div>
            </form>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40">Explore</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li><Link to="/how-it-works" className="hover:text-crimson">How Leasing Works</Link></li>
              <li><Link to="/products" className="hover:text-crimson">Browse iPhones</Link></li>
              <li><Link to="/apply" className="hover:text-crimson">Apply for Leasing</Link></li>
              <li><Link to="/contact" className="hover:text-crimson">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40">Promise</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-crimson" /> 1-Year Warranty</li>
              <li>Free UPS Shipping</li>
              <li>30-Day Returns</li>
              <li>PhoneCheck Certified</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Adopt-A-Phone™. All rights reserved.</span>
          <span className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> Leasing provided via the Payvantage leasing program.</span>
        </div>
      </div>
    </footer>
  );
}
